<template>
  <div v-if="loggedIn" class="ml-4 mr-12 mt-8">
    <v-card flat>
      <v-toolbar flat>
        <v-row>
          <v-col cols="9" class="title blue--text">
            <v-breadcrumbs :items="crumbs">
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  ><router-link :to="item.to">{{
                    item.text.toUpperCase()
                  }}</router-link>
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-col>
          <v-col cols="3">
            <v-row justify="end"
              ><v-autocomplete
                v-model="selected"
                :items="items"
                :loading="isLoading"
                :search-input.sync="search"
                item-text="name"
                item-value="id"
                color="primary"
                hide-no-data
                hide-selected
                label="Search"
                prepend-icon="mdi-magnify"
                return-object
                @change="onSelChange"
              ></v-autocomplete>
            </v-row>
          </v-col>
        </v-row>
      </v-toolbar>
    </v-card>
  </div>
</template>

<script>
import _ from 'lodash'

const courseCrumb = 'Summary'

export default {
  data() {
    return {
      descriptionLimit: 60,
      items: [],
      isLoading: false,
      selected: null,
      search: null
    }
  },
  methods: {
    onSelChange(value) {
      if (this.selected != null) {
        const whereTo = this.selected.type === 'agent' ? '/agent/' : '/courses/'
        this.$router.push({
          path: `${whereTo}${this.selected.id}`
        })

        this.selected = null
        this.isLoading = false
      }
    }
  },
  computed: {
    loggedIn() {
      return this.$store.getters['user/loggedIn']
    },
    hasCourses() {
      return this.$store.getters['course/hasCourses']
    },
    crumbs: function() {
      let pathArray = this.$route.path.split('/')
      pathArray.shift()
      const route = this.$route
      const size = pathArray.length

      let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
        let text = ''
        let to = 'courses'
        let disabled = false
        if (path === 'courses' || path === '') {
          text = courseCrumb
          to = { path: '/courses' }
          disabled = size === 1

          breadcrumbArray.push({
            to: to,
            text: text,
            disabled: disabled
          })
        } else {
          if (
            route.params.course !== undefined &&
            route.params.course != null
          ) {
            if (
              route.query != null &&
              route.query !== undefined &&
              route.query.agentName != null &&
              route.query.agentName !== undefined
            ) {
              text = route.params.course.name
              to = {
                name: 'course-detail',
                params: { courseId: route.params.courseid }
              }
              breadcrumbArray.push({
                to: to,
                text: text,
                disabled: disabled
              })

              text = route.query.agentName
              to = {
                name: 'agent-courses',
                params: { agentId: route.query.agentId }
              }
            } else {
              text = route.params.course.name
              to = {
                name: 'course-detail',
                params: { courseId: route.params.courseid }
              }
            }
            breadcrumbArray.push({
              //path: path,
              to: to,
              text: text,
              disabled: disabled
            })
          } else if (
            route.params.agent !== undefined &&
            route.params.agent != null
          ) {
            text = 'Summary'
            to = { path: '/courses' }
            disabled = size === 1

            let existingCrumb = _.find(breadcrumbArray, { text: text })
            if (existingCrumb == null || existingCrumb === undefined) {
              breadcrumbArray.push({
                //path: path,
                to: to,
                text: text,
                disabled: disabled
              })
            }
          }
        }
        if (
          breadcrumbArray[1]?.to?.name === 'course-detail' &&
          route.params?.course?.courseId?.includes('/public')
        ) {
          breadcrumbArray[1].text = breadcrumbArray[1].text + ' (Public)'
        }
        return breadcrumbArray
      }, [])
      return breadcrumbs
    }
  },
  watch: {
    search(val) {
      // Items have already been loaded
      // /if (this.items.length > 0) return
      if (val == null) return

      // Items have already been requested
      if (this.isLoading) return

      this.isLoading = true

      // Lazily load input items
      this.$store
        .dispatch('course/search', val)
        .then(res => {
          this.items = res.map(e => {
            if (e.courseId && e.courseId.includes('/public')) {
              e.name = e.name + ' (Public)'
            }
            return e
          })
        })
        .catch(err => {})
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
// .nav {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   height: 60px;
// }
// .nav > .brand {
//   font-family: 'Montserrat', sans-serif;
//   font-weight: 700;
//   font-size: 1.5em;
//   color: #39b982;
//   text-decoration: none;
// }
// .nav .nav-item {
//   box-sizing: border-box;
//   margin: 0 5px;
//   color: rgba(0, 0, 0, 0.5);
//   text-decoration: none;
// }
// .nav .nav-item.router-link-exact-active {
//   color: #39b982;
//   border-bottom: solid 2px #39b982;
// }
</style>
